import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Button,
} from "@mui/material";
import { getUserPermissions } from "src/utils/permissionsUtils";
import Iconify from "../iconify/Iconify";
import { fDateTime } from "src/utils/formatTime";

const calculageJackpot = (row) => {
  if (row.winnerUserId) {
    return row.winnerAmount;
  }
  const currentDate = new Date();
  const startDate = new Date(row.startDate);
  const timeDiff = currentDate.getTime() - startDate.getTime();
  const minutesDiff = Math.floor(timeDiff / (1000 * 60));
  const jackpotAmount = row.startAmount + minutesDiff;
  return jackpotAmount;
};

const calculagePossibility = (row, specialChance) => {
  if (row.winnerUserId) {
    return "--";
  }
  if (specialChance?.enabled) {
    return `${specialChance.percent ?? 12} % (special)`;
  }
  const currentDate = new Date();
  const startDate = new Date(row.startDate);
  const timeDiff = currentDate.getTime() - startDate.getTime();
  const minutesDiff = Math.floor(timeDiff / (1000 * 60));
  const daysDiff = Math.floor(minutesDiff / (60 * 24));
  const possibilityOfJackpot = row.possibilities[daysDiff] ?? 100;
  return possibilityOfJackpot + " %";
};
const { isViewer } = getUserPermissions();

export default function MegaspinsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Start Date</TableCell>
            <TableCell>Jackpot</TableCell>
            <TableCell>Possibility</TableCell>
            <TableCell>Winner</TableCell>
            <TableCell>Winner Time</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.rows?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {fDateTime(row.startDate)}
              </TableCell>
              <TableCell component="th" scope="row">
                {calculageJackpot(row)}
              </TableCell>
              <TableCell component="th" scope="row">
                {calculagePossibility(row, props.specialChance)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.winnerUserId ? (
                  <a href={`/dashboard/profile?user_id=${row.winnerUserId}`}>
                    {row.winnerUserId}
                  </a>
                ) : (
                  "--"
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.winnerDate ? fDateTime(row.winnerDate) : "--"}
              </TableCell>
              {!isViewer && (
                <TableCell component="th" scope="row">
                  <Button
                    onClick={() => props.onEdit(row)}
                    variant="contained"
                    endIcon={
                      <Iconify icon={"eva:edit-fill"} width={16} height={16} />
                    }
                  >
                    Edit
                  </Button>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
